import { Routes, Route } from "react-router-dom";

import Invoices from "./Invoices";
import InvoiceEdit from "./InvoiceEdit";
import InvoiceDetails from "./InvoiceDetails";
import InvoiceCreate from "./InvoiceCreate";
import { CharterType } from "__generated__/enums";

const index = () => {
	return (
		<Routes>
			<Route path="/purchase">
				<Route index element={<Invoices charterType={CharterType.Purchase} />} />
				<Route path="new" element={<InvoiceCreate charterType={CharterType.Purchase} />} />
			</Route>
			<Route path="/sale">
				<Route index element={<Invoices charterType={CharterType.Sales} />} />
				<Route path="new" element={<InvoiceCreate charterType={CharterType.Sales} />} />
			</Route>
			<Route path="/:id/edit" element={<InvoiceEdit />} />
			<Route path="/:id/details" element={<InvoiceDetails />} />
		</Routes>
	);
};

export default index;
